import { logError } from "../../../shared/functions/misc";
import Booking from "../../../shared/functions/booking";
import Store from "../../../shared/functions/store";
import { int } from "@phoenixreisen/form";
import Context from "../shared/context";
import User from "@phoenixreisen/user";
import Config from "../../../config";
import striptags from "striptags";
import m from "mithril";
export class View {
    fields = {
        booknr: int(),
    };
    submitting = false;
    failure = null;
    oninit() {
        if (!User.isLoggedIn()) {
            m.route.set("/agentur");
        }
    }
    async submit(e) {
        const { booknr } = this.fields;
        const { urls, storageKeyBookingNr } = Config;
        e?.preventDefault();
        booknr.validate(booknr.value());
        if (!booknr.complaint) {
            this.failure = null;
            this.submitting = true;
            Store.set(storageKeyBookingNr, booknr.value());
            await Booking.getBookingByNr(Booking.getBookingNr(User), true, "XL")
                .then((booking) => {
                if (booking && booking["buchung/agentur-mandat?"] === false) {
                    this.failure = new Error("no-mandate");
                }
                else if (booking?.["buchung/umleitung-url"]?.length > 0) {
                    this.failure = new Error("redirect");
                }
                else {
                    location.href = urls.OVERVIEW;
                }
            })
                .catch((error) => {
                this.failure = error;
                Store.remove(storageKeyBookingNr);
                logError(error);
            })
                .finally(() => {
                this.submitting = false;
                m.redraw();
            });
        }
        m.redraw();
    }
    view() {
        const { html, urls } = Config;
        const { webtexte: wt } = Context;
        const { booknr } = this.fields;
        const { failure, submitting } = this;
        try {
            return (m("form", { class: "form login-form", onsubmit: (e) => this.submit(e) },
                !!wt?.["agenturlogin__infosatz"] && (m("p", { class: "alert alert--info alert--icon mb3" },
                    m("i", { class: "fas fa-info-circle ml1 mr2" }),
                    m("small", null, m.trust(striptags(wt["agenturlogin__infosatz"], html.allowed))))),
                failure && failure.message === "no-mandate" && (m("div", { class: "alert alert--danger" }, wt["agenturlogin__mandat_entzogen"] ? (m.trust(striptags(wt["agenturlogin__mandat_entzogen"], html.allowed))) : (m("div", null, "Der Kunde hat Ihnen die Erlaubnis entzogen, in seinem Namen handeln zu d\u00FCrfen.")))),
                failure && failure.message === "redirect" && (m("div", { class: "alert alert--danger" },
                    m("div", null, "Diese Buchung wird zurzeit \u00FCberarbeitet. Bitte versuchen Sie es sp\u00E4ter erneut."))),
                failure &&
                    failure.message !== "no-mandate" &&
                    failure.message !== "redirect" && (m("div", { class: "alert alert--danger alert--icon" },
                    m("i", { class: "fas fa-exclamation-triangle" }),
                    wt["agenturlogin__buchung_nicht_gefunden"] ? (m.trust(striptags(wt["agenturlogin__buchung_nicht_gefunden"], html.allowed))) : (m("div", null,
                        "Beim Abrufen der Buchung ist leider ein Fehler aufgetreten. Bitte versuchen Sie es sp\u00E4ter noch einmal oder wenden Sie sich an unsere",
                        " ",
                        m("a", { href: "mailto:it@phoenixreisen.com" }, "IT-Abteilung"),
                        ".")))),
                booknr.value() && booknr.complaint && (m("div", { class: "alert alert--danger alert--icon" },
                    m("i", { class: "fas fa-exclamation-triangle" }),
                    "Bitte \u00FCberpr\u00FCfen Sie Ihre Eingabe. Es scheint sich nicht um eine korrekte Buchungsnummer zu handeln.")),
                m("label", { class: "textfield custom-field" },
                    m("input", { type: "text", name: "second", maxLength: "7", autocomplete: "bookingnr", value: booknr.value(), oninput: (e) => {
                            this.failure = null;
                            booknr.validate(e.target.value.replace(/[^0-9]/g, ""));
                        } }),
                    m("span", { class: `textfield__label ${booknr.complaint ? "alert--warning" : ""}` }, "Buchungsnummer")),
                m("div", { class: "tr" },
                    m("button", { type: "submit", disabled: submitting },
                        submitting && m("i", { class: "fas fa-spinner fa-spin mr2" }),
                        m("span", null, "F\u00FCr diese Buchung handeln")))));
        }
        catch (e) {
            logError(e);
            location.href = urls.FE_ERROR;
        }
    }
}
export default View;
